import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'

import { languageService } from '../services/languageService'

import translationSR from '../locales/sr/translation.json'
import translationSR_lat from '../locales/sr_lat/translation.json'

const resources = {
    sr: {
        translation: translationSR
    },
    sr_lat: {
        translation: translationSR_lat
    }
}

i18n.use(initReactI18next).init({
    resources,
    lng: languageService.activeLanguage ? languageService.activeLanguage : 'sr',

    // debug: true,

    keySeparator: false,
    interpolation: {
        escapeValue: false // not needed for react!!
    },
    returnObjects: true
})

export default i18n
